import React from "react";
import "./listaMateriais.css";

export function normalizarImagensMaterial(material = {}) {
  const fonte =
    material.ImagensMaterial ??
    material.imagensMaterial ??
    material.ImagemMaterial ??
    material.imagemMaterial ??
    material.ImagemUrl ??
    material.imagemUrl ??
    material.Imagem ??
    material.imagem ??
    [];

  let lista;
  if (Array.isArray(fonte)) lista = fonte;
  else if (typeof fonte === "string") lista = [fonte];
  else if (fonte && typeof fonte === "object") {
    const temUrlDireta = fonte.url || fonte.downloadURL || fonte.link || fonte.src;
    lista = temUrlDireta ? [fonte] : Object.values(fonte);
  } else lista = [];

  return lista
    .map((imagem, index) => {
      if (typeof imagem === "string") {
        return { id: `imagem-${index + 1}`, nome: `Imagem ${index + 1}`, url: imagem };
      }

      const url = imagem?.url || imagem?.downloadURL || imagem?.link || imagem?.src || "";
      return {
        ...imagem,
        id: imagem?.id || `imagem-${index + 1}`,
        nome: imagem?.nome || imagem?.name || `Imagem ${index + 1}`,
        url,
      };
    })
    .filter((imagem) => Boolean(imagem.url));
}

    function ListaMateriais({
      arrayEnsaios = [],
      editar,
       clonar,
      alterarStatus,
      abrirHistorico,
      abrirImagens,
      mapaObras = {} // 🔥 ADICIONAR
    }) {
      return (
        <div className="tabela-container">
          <table className="table table-hover cadastro-tabela lista-cadastro-padrao">
        <thead>
          <tr>
            <th>Código</th>
            <th>Data</th>
            <th>Cliente</th>
            <th>Obra</th>
            <th>Fornecedor</th>
            <th>Local Coleta</th>
            <th>Descrição</th>
            <th>Imagem</th>
            <th>Ações</th>
          </tr>
        </thead>

        <tbody>
          {arrayEnsaios.length === 0 && (
            <tr>
              <td colSpan={9} className="text-center">
                Nenhum registro encontrado.
              </td>
            </tr>
          )}

          {arrayEnsaios.map((ensaio) => {
            const pendente = ensaio.edicaoPendente;
            const imagens = normalizarImagensMaterial(ensaio);

            return (
              <tr
                key={ensaio.id}
                className={pendente ? "linha-pendente" : ""}
              >
                <td>{ensaio.codigo}</td>

                <td className="lista-dado-secundario">
                  {ensaio.DataCadastro?.seconds
                    ? new Date(ensaio.DataCadastro.seconds * 1000)
                        .toLocaleDateString("pt-BR", { timeZone: "UTC" })
                    : ""}
                </td>

                <td className="col-cliente lista-dado-principal">
                <div className="texto-quebra">
                  {ensaio.Cliente}
                </div>
              </td>

              <td className="col-obra lista-dado-principal">
                <div className="texto-quebra">
                  {mapaObras[ensaio.ObraId] || "-"}
                </div>
              </td>
                <td className="lista-dado-destaque">{ensaio.Fornecedor}</td>

                  <td className="lista-dado-secundario">
                    {ensaio.LocalColeta || "-"}
                  </td>

                  <td className="lista-dado-secundario">{ensaio.Descricao}</td>

                <td className="col-acao">
                  {imagens.length > 0 ? (
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => abrirImagens && abrirImagens(ensaio)}>
                      Visualizar
                    </button>
                  ) : "-"}
                </td>

                <td className="col-acao">
                  {pendente && (
                    <div className="pendente-label">
                      Alteração pendente
                    </div>
                  )}

                  <i
                    className={`fas fa-edit icone-acao ${
                      pendente ? "disabled-icon" : ""
                    }`}
                    title={
                      pendente
                        ? "Existe uma alteração pendente"
                        : "Editar"
                    }
                    onClick={() =>
                      !pendente && editar && editar(ensaio)
                    }
                  />
                  <i
                    className="fas fa-copy icone-acao"
                    title="Clonar"
                    onClick={() => clonar && clonar(ensaio)}
                  />
                  <i
                    className="fas fa-history icone-acao"
                    title="Histórico"
                    onClick={() =>
                      abrirHistorico && abrirHistorico(ensaio)
                    }
                  />
                </td>

              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ListaMateriais;
